export var DriversLicenseStatus;
(function (DriversLicenseStatus) {
    DriversLicenseStatus["Valid"] = "Valid";
    DriversLicenseStatus["Invalid"] = "Invalid";
})(DriversLicenseStatus || (DriversLicenseStatus = {}));
